var _defs, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMascotSleep(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 945.01 588.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #ff5e46;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #28082a;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M945.01,418.21h-48.56v-247.06c0-58.35-47.74-106.08-106.08-106.08-26.66,0-51.08,9.99-69.77,26.37h-.03s-.28.27-.28.27c-3.28,2.9-6.38,6-9.29,9.28l-142.66,142.48h0c-.8.75-1.58,1.49-2.35,2.25V107.19c0-58.35-47.74-106.08-106.08-106.08-26.66,0-51.08,9.99-69.77,26.37h-.03s-.28.27-.28.27c-3.28,2.9-6.38,6-9.29,9.28l-142.66,142.48h0c-1.42,1.32-2.8,2.67-4.15,4.05V0H0v170.11h48.56v418.42h847.9v-.21h48.56v-170.11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M637.59,558.64c-47.87,0-86.82-38.95-86.82-86.82,0-3.64,2.95-6.59,6.59-6.59s6.59,2.95,6.59,6.59c0,40.6,33.03,73.64,73.64,73.64s73.64-33.03,73.64-73.64c0-3.64,2.95-6.59,6.59-6.59s6.59,2.95,6.59,6.59c0,47.87-38.95,86.82-86.82,86.82Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M307.34,558.64c-47.87,0-86.82-38.95-86.82-86.82,0-3.64,2.95-6.59,6.59-6.59s6.59,2.95,6.59,6.59c0,40.6,33.03,73.64,73.64,73.64s73.64-33.03,73.64-73.64c0-3.64,2.95-6.59,6.59-6.59s6.59,2.95,6.59,6.59c0,47.87-38.95,86.82-86.82,86.82Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascotSleep);
export default __webpack_public_path__ + "static/media/mascot-sleep.04c4f3b59fa715344c7f559790551709.svg";
export { ForwardRef as ReactComponent };